import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	commitment: {
		id: 'software-reports.velocity-report.chart.commitment',
		defaultMessage: 'Commitment',
		description: '',
	},
	commitmentDescription: {
		id: 'software-reports.velocity-report.chart.commitment-description',
		defaultMessage: 'The amount of work in the sprint when it began.',
		description: 'Legend Description for Commitment',
	},
	completed: {
		id: 'software-reports.velocity-report.chart.completed',
		defaultMessage: 'Completed',
		description: '',
	},
	completedDescription: {
		id: 'software-reports.velocity-report.chart.completed-description',
		defaultMessage: 'The amount of work done during the sprint.',
		description: 'Legend Description for Completed',
	},
	loading: {
		id: 'software-reports.velocity-report.chart.loading',
		defaultMessage: 'Loading sprint data',
		description: 'Indicates the page is waiting for sprint data from the server',
	},
});
